import formatBasisPoints from '../../public/formatBasisPoints/formatBasisPoints';
import formatCurrency from '../../public/formatCurrency/formatCurrency';
import formatDateTime from '../../public/formatDateTime/formatDateTime';
import formatDisplayName from '../../public/formatDisplayName/formatDisplayName';
import formatList from '../../public/formatList/formatList';
import formatMessage from '../../public/formatMessage/formatMessage';
import formatNumber from '../../public/formatNumber/formatNumber';
import formatPercent from '../../public/formatPercent/formatPercent';
import formatRelativeTime from '../../public/formatRelativeTime/formatRelativeTime';
import isTranslated from '../../public/isTranslated/isTranslated';
export default function createIntlObject(config, reports, analytics) {
    return {
        formatBasisPoints: formatBasisPoints.bind(null, config, reports, analytics),
        formatCurrency: formatCurrency.bind(null, config, reports),
        formatDateTime: formatDateTime.bind(null, config, reports, analytics),
        formatDisplayName: formatDisplayName.bind(null, config, reports),
        formatList: formatList.bind(null, config, reports),
        formatMessage: formatMessage.bind(null, config, reports, analytics),
        formatNumber: formatNumber.bind(null, config, reports, analytics),
        formatPercent: formatPercent.bind(null, config, reports, analytics),
        formatRelativeTime: formatRelativeTime.bind(null, config, reports, analytics),
        isTranslated: isTranslated.bind(null, config, reports, analytics),
        locale: config.locale
    };
}

//# sourceMappingURL=createIntlObject.js.map